import { render, staticRenderFns } from "./EmpleadoDescuentos.vue?vue&type=template&id=1e5d41a1&"
import script from "./EmpleadoDescuentos.vue?vue&type=script&lang=js&"
export * from "./EmpleadoDescuentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports